import api from "./apiService";

export const getExpertizes = (data) => api().post(`/admin/getExpertizes`, data).then(response => response); 

export const addExpertize = (data) => api().post(`/admin/addExpertize`, data).then(response => response); 

export const updateExpertize = (id, data) => api().put(`/admin/updateExpertize/${id}`, data).then(response => response); 

export const removeExpertize = (id, data) => api().delete(`/admin/removeExpertize/${id}`).then(response => response); 

export const upateExpertiseStatus = (id, data) => api().put(`/admin/upateExpertiseStatus/${id}`, data).then(response => response); 

export const getExpertiseFilter = (data) => api().get(`/admin/getExpertiseFilter`).then(response => response); 

export const getSubExpertiseByExpertise = () => api().get(`/admin/getSubExpertiseByExpertise`).then(response => response); 

export const getSubExpertises = (data) => api().post(`/admin/getSubExpertises`, data).then(response => response); 
export const addSubExpertise = (data) => api().post(`/admin/addSubExpertise`, data).then(response => response); 
export const updateSubExpertise = (id, data) => api().put(`/admin/updateSubExpertise/${id}`, data).then(response => response); 
export const removeSubExpertise = (id, data) => api().delete(`/admin/removeSubExpertise/${id}`).then(response => response); 
// export const getSubExpertisesByTopic = () => api().get(`/admin/getSubExpertisesByTopic`).then(response => response); 



const services = {
    getExpertizes,
    addExpertize,
    updateExpertize,
    removeExpertize    
}


export default services;